import React from 'react';
import classNames from 'classnames';
import styles from './Heading.module.scss';

export default function Heading({ children, className }) {
  return <p className={classNames(styles.heading, className)}>{children}</p>;
}
